export enum SortPredictionMarketEnum {
  Recommended = "おすすめ",
  RapidlyRising = "急上昇中",
  Popular = "人気順",
  NewArrivals = "新着順",
  ClosingSoon = "締切間近",
  FiftyFifty = "50:50",
}

type OrderBy = "popularity" | "creation";

type Dynamic = string;
export type LabelData = "New" | "人気" | Dynamic;
export type SubLabelData = {
  id: string;
  label: string;
};

type getPredictionMarketLabelQueriesResult = {
  displayText: string;
  queryLabel?: string;
  orderBy: OrderBy;
  querySubLabel?: string;
};

export const getPredictionMarketLabelQueries = (
  label: LabelData,
  subLabel?: SubLabelData,
): getPredictionMarketLabelQueriesResult => {
  const displayText = getPredictionMarketLabelDisplay(label);
  const queryLabel = getLabelForQuery(label);
  const querySubLabel = getSubLabelForQuery(label, subLabel);
  const orderBy = getPredictionMarketOrder(label);

  return {
    displayText,
    queryLabel,
    querySubLabel,
    orderBy,
  };
};

export const getQueryFilterSpecification = (filterType: SortPredictionMarketEnum): string => {
  switch (filterType) {
    case SortPredictionMarketEnum.Recommended:
      return "Recommended";
    case SortPredictionMarketEnum.RapidlyRising:
      return "RapidlyRising";
    case SortPredictionMarketEnum.Popular:
      return "Popular";
    case SortPredictionMarketEnum.NewArrivals:
      return "NewArrivals";
    case SortPredictionMarketEnum.ClosingSoon:
      return "ClosingSoon";
    case SortPredictionMarketEnum.FiftyFifty:
      return "FiftyFifty";
    default:
      return "Recommended";
  }
};

const getPredictionMarketLabelDisplay = (label: LabelData): string => {
  if (label === "New") {
    return "NEW";
  }
  return label;
};

const getLabelForQuery = (label: LabelData): string | undefined => {
  if (label === "New" || label === "人気") {
    return undefined;
  }
  return label;
};

const getSubLabelForQuery = (label: LabelData, subLabel?: SubLabelData): string | undefined => {
  if (subLabel?.id !== `${label}-${subLabel?.label}` || subLabel?.label === "すべて") {
    return undefined;
  }
  return subLabel?.label;
};

const getPredictionMarketOrder = (label: LabelData): OrderBy => {
  if (label === "人気") {
    return "popularity";
  }
  return "creation";
};
